import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHits } from 'react-instantsearch';

import { SearchResultsInfinite } from '@uncinc/react-searchkit';
import type { ShowMoreButtonProps } from '@uncinc/react-searchkit/types';

import Button from '../../Button';
import SearchAllContent from '../../SearchAllContent';
import { byProjectRequestOptions, hitsPerPage, searchSettings } from '../config';
import renderRelatedHit from '../renderHit';
import RelatedContent from '..';

const ShowMoreButton: React.FC<ShowMoreButtonProps> = (props) => (
  <Button
    {...props}
    className="RelatedContent__read-more"
    type="secondary"
    icon="chevron_down"
  />
);

interface RelatedContentByProjectProps {
  projectId: number;
  className?: string;
}

const RelatedContentByProjectInner: React.FC<Pick<RelatedContentByProjectProps, 'className'>> = ({
  className,
}) => {
  const { hits } = useHits();
  const { t } = useTranslation();

  if (!hits.length) {
    return null;
  }

  return (
    <RelatedContent className={className}>
      <RelatedContent.Title title={t('components.related_content.title_project')} />
      <SearchResultsInfinite
        className="RelatedContent__items"
        renderItem={renderRelatedHit}
        showMoreButton={ShowMoreButton}
      />
    </RelatedContent>
  );
};

const RelatedContentByProject: React.FC<RelatedContentByProjectProps> = ({
  projectId,
  className,
}) => {
  const requestOptions = useMemo(() => byProjectRequestOptions(projectId), [projectId]);

  return (
    <SearchAllContent
      hitsPerPage={hitsPerPage}
      searchSettings={searchSettings}
      requestOptions={requestOptions}
    >
      <RelatedContentByProjectInner className={className} />
    </SearchAllContent>
  );
};

export default RelatedContentByProject;
